// 医院外链
const outerRouter = [
  {
    path: "/reportListOuter",
    name: "reportListOuter",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportListOuter/index"), "reportListOuter")
      ),
    meta: {
      title: "全部检查",
    },
  },
  // 承德双滦区人民医院
  {
    path: "/checkInfoOuter/search", 
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/cdSearch"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  // 国传外链
  {
    path: "/reportListQuery",
    name: "reportListQuery",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportListQuery/index"), "reportListQuery")
      ),
    meta: {
      title: "全部检查",
    },
  },
  {
    path: "/reportInfoQuery",
    name: "reportInfoQuery",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportInfoQuery/index"), "reportInfoQuery")
      ),
    meta: {
      title: "医院数字影像查询系统",
    },
  },
  {
    path: "/reportInfoOuter",
    name: "reportInfoOuter",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportInfoOuter/index"), "reportInfoOuter")
      ),
    meta: {
      title: "医院数字影像查询系统",
    },
  },
  // 安全转发链接专用入口，与 reportInfoOuter 保持完全一致
  {
    path: "/reportInfoShare",
    name: "reportInfoShare",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportInfoShare/index"), "reportInfoShare")
      ),
    meta: {
      title: "医院数字影像查询系统",
    },
    hidden: true,
  },
  {
    path: "/reportInfoOuter_GZ",
    name: "reportInfoOuter_GZ",
    component: (r) =>
      require.ensure([], () =>
        r(
          require("@/views/outerLink/reportInfoOuter_GZ/index"),
          "reportInfoOuter_GZ"
        )
      ),
    meta: {
      title: "医院数字影像查询系统",
    },
  },
  {
    path: "/reportListOuter_JX",
    name: "reportListOuter_JX",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/reportInfoOuter_JX/reportList/index"), "reportListOuter")
      ),
    meta: {
      title: "全部检查",
    },
  },
  {
    path: "/reportInfoOuter_JX",
    name: "reportInfoOuter_JX",
    component: (r) =>
      require.ensure([], () =>
        r(
          require("@/views/outerLink/reportInfoOuter_JX/index"),
          "reportInfoOuter_JX"
        )
      ),
    meta: {
      title: "医院数字影像查询系统",
    },
  },
  {
    path: "/printOuter",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/stampOuter/index"), "print")
      ),
    meta: {
      title: "检查报告单",
    },
    hidden: true,
  },
  // 73000005 榆中县第一人民医院 定制化打印页
  {
    path: "/printOuter1",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/stampOuter/yuzhongstamp"), "print")
      ),
    meta: {
      title: "检查报告单",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/27400005", // 东明县第二人民医院
    name: "checkInfoOuter",
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/index"), "checkInfoOuter")
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/25500004", // 淄博市中医医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/25500004"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/41000009", // 长沙乐好妇产医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/index"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/52200003", // 揭西县人民医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/52200003"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/43800001", // 武穴市第一人民医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/43800001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/46700002", // 平顶山市第二人民医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/46700002"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/43600001", // 鄂州市中心医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/43600001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/75000001", // 银川市口腔医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/75000001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/27400007", // 单县正大康复医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/27400007"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/27100005", // 山东颐养健康集团肥城医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/27100005"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/71900005", // 绥德县医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/71900005"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/71900006", // 米脂县医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/71900006"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/71900007", // 榆林市第一医院榆林院区
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/71900007"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/71900008", // 榆林市第一医院绥德院区
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/71900008"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/27100006", // 泰安市岱岳区妇幼保健院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/27100006"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/25500005", // 山东颐养健康集团莱芜中心医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/25500005"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/06700001", // 承德市中医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/06700001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/74400013", // 崇信县中医医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/74400013"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/71900001", // 榆林市第四（星元）医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/71900001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/27100009", // 东平县疾病预防控制中心
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/27100009"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/73000005", // 榆中县第一人民医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/73000005"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/72700001", // 铜川矿务局中心医院
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/72700001"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/checkInfoOuter/30000004", // 天津大学新城医院（天津新城铂颂医院）
    component: (r) =>
      require.ensure([], () =>
        r(require("@/views/outerLink/checkInfoOuter/30000004"))
      ),
    meta: {
      title: "绑定检查信息",
    },
    hidden: true,
  },
  {
    path: "/jump",
    component: (r) =>
      require.ensure([], () => r(require("@/views/jump/index"), "jump")),
    meta: {
      title: "我的报告",
    },
    hidden: true,
  },
];
export default outerRouter;
